import {
	Component,
	EventEmitter,
	Input,
	Output,
	booleanAttribute,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { SafeHtmlPipe } from "@app/utils/safe-html.pipe"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"
import { CanvasWriteComponent } from "@app/canvas-write/canvas-write.component"
import { InviteBtn } from "@app/policy-form-invite/invite-btn"

@Component({
	selector: "app-policy-form-fill",
	imports: [
		COMMON_IMPORTS,
		SafeHtmlPipe,
		GenInputComponent,
		GenButtonGroupComponent,
		LangValPipe,
		CancelBtnComponent,
		BtnExtComponent,
		CanvasWriteComponent,
		InviteBtn,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./policy-form-fill.component.html",
})
export class PolicyFormFillComponent extends Modalable {
	modalProps: any = null
	isSaving: boolean = false
	isSendingInvite: boolean = false

	@Input() state: string
	@Input() version_id: number = 0
	@Input() person_id: number = 0
	@Input() person_type: string
	@Input({ transform: booleanAttribute }) isNested: boolean = false
	@Output() onFinish = new EventEmitter()
	@Output() onSaveState = new EventEmitter()

	version: any = null
	person: any = null
	isFormSubmittable: boolean = false
	validationRules: any = { answer: { not_empty: true } }
	sign_img_blob: any = null
	signErr: string = ""
	saveInt: any = null

	ngOnDestroy() {
		clearInterval(this.saveInt)
	}
	ngOnInit() {
		if (this.person_id) {
			this.person = this.store.getPerson(this.person_id, this.person_type)
		}
		this.version = this.store.searchSiteDataItem(this.version_id, [
			"policy_form_versions",
		])
		if (!this.version) {
			return
		}
		this.version.policyForm = this.store.searchSiteDataItem(
			this.version.policy_form_id,
			["policy_forms"]
		)
		this.version.fields = this.store
			.getSiteDataTable("policy_form_version_fields")
			.filter((field) => field.version_id == this.version.id)
			.toSorted((a, b) => a.order_num - b.order_num)
		this.version.fields.forEach((field) => {
			field.answer = ""
			field.errors = {}
			if (field.options?.length) {
				field.optionsArr = JSON.parse(field.options)
			}
		})

		if (this.state) {
			const fields = JSON.parse(this.state)
			fields.forEach(({ id, answer }) => {
				this.prepStateField(id, answer)
			})
		}
		if (this.onSaveState) {
			this.saveInt = setInterval(() => {
				this.onSaveState.emit(this.version)
			}, 10 * 1000)
		}
	}
	prepStateField(fieldId: number, answer: any) {
		if (!this.version.fields?.length) {
			return
		}
		const field = this.version.fields.find((it) => it.id == fieldId)
		if (!field) {
			return
		}
		field.answer = answer
		this.validateEntireForm()
		if (!answer) {
			return
		}
		if (field.field_type === "opts-checkbox") {
			return this.onCheck(
				field,
				field.optionsArr.find((opt) => opt.value == answer)
			)
		}
	}

	validateEntireForm() {
		this.isFormSubmittable = true
		this.version.fields
			.filter((field) => field.required === "yes")
			.forEach((field) => {
				field.errors = {}
				const hasNoErrors = this.validator.validateEntireForm(
					field,
					field.errors,
					this.validationRules
				)
				if (!hasNoErrors) {
					this.isFormSubmittable = false
				}
			})
		if (this.version.policyForm?.sign_required == "yes") {
			this.signErr = ""
			if (!this.sign_img_blob) {
				this.signErr = this.lang.getVal("should_be_signed")
				this.isFormSubmittable = false
			}
		}
	}

	async save() {
		this.isSaving = true
		if (this.version.policyForm?.sign_required == "yes") {
			this.version.sign_img_blob = this.sign_img_blob
		}
		await this.store.downloadToastFunc(async () => {
			const resPdf = await this.apiService.download("fill_policy_form", {
				...this.version,
				person_id: this.person_id,
				person_type: this.person_type,
			})
			if (!resPdf?.size) {
				return this.modalService.openToast("save_failed")
			}
			this.apiService.downloadFile(
				resPdf,
				this.lang.getVal("policy_form") + ".pdf"
			)
		})
		this.modalService.openToast("save_process")
		this.isSaving = false
		this.onClose.emit(true)
	}
	onCheck(field: any, opt: any) {
		field.answer = opt.value
		this.validateEntireForm()
	}
}
